import { MESSAGE_TYPES } from '../constants';

export const resolveMessageSenderName = ({
  sender,
  additionalAttributes,
} = {}) => sender?.name || additionalAttributes?.senderName || '';

export const shouldShowSenderLabel = ({
  messageType,
  isPrivate = false,
  shouldGroupWithNext = false,
  externalEcho = false,
  senderName = '',
} = {}) =>
  messageType === MESSAGE_TYPES.OUTGOING &&
  !isPrivate &&
  !shouldGroupWithNext &&
  !externalEcho &&
  Boolean(senderName);
